export interface ApiErrorMessageModel {
  errorCode: string;
  errorDetails: string;
}
